import { FC } from 'react';
import ProductHeader from '../ProductHeader';
import styled from './index.module.scss';
import MiddleCard from './MiddleCard';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps } from '@/components/MembersDay/type';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

const PiecesProduct: FC<IProductProps> = ({ module, icon, title, desc, id }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);
    const { isLogin } = useMembersStore();

    if (!productList || productList.length < 0) return <></>;

    return (
        <div className={`${styled.Horizonta}`} id={id}>
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className="list_box_row">
                {productList.map((item) => (
                    <MiddleCard key={item.variantId} title={title} data={item} skipLogin={true} entry_position={6} />
                ))}
            </div>
        </div>
    );
};

export default PiecesProduct;
